
import React, { useState, useEffect } from "react"
import { antIcon } from "../dashboard/Dashboard"
import {
  IPayScheduleItemDocsEntity,
  IPayScheduleItemRes,
} from "./crossborder/interface/payouts"
import { ColumnsType, TableRowSelection } from "antd/es/table/interface"
import { AppTable } from "components/new-stuff/app-table"
interface PaymentSelectionItem {
  payment_schedule_item_id: string
}
interface props {
  TableColumns: ColumnsType<IPayScheduleItemDocsEntity>
  TableData: IPayScheduleItemDocsEntity[]
  rowKey: (record: IPayScheduleItemDocsEntity) => string | number
  isPaymentLoading: boolean
  submitSelection: (items: PaymentSelectionItem[]) => void
  submitDeselection: (items: PaymentSelectionItem[]) => void
  setAllSelectedRowSum: (sum: number) => void
  setFilteredData: (data: IPayScheduleItemDocsEntity[]) => void
  payoutData: IPayScheduleItemRes
  setPagination: React.Dispatch<
    React.SetStateAction<{
      page: number
      limit: number
    }>
  >
}
export const SelectedTable: React.FC<props> = ({
  TableColumns,
  TableData,
  rowKey,
  isPaymentLoading,
  submitSelection,
  submitDeselection,
  setAllSelectedRowSum,
  setFilteredData,
  payoutData,
  setPagination,
}) => {
  const [allSelectedRowKeys, setAllSelectedRowsKeys] = useState<any[]>([])

  const rowSelection: TableRowSelection<IPayScheduleItemDocsEntity> = {
    onSelect: (record) => {
      let found = allSelectedRowKeys.find((itm) => itm == rowKey(record))

      if (found) {
        submitDeselection([
          {
            payment_schedule_item_id: String(found),
          },
        ])
      } else {
        submitSelection([
          {
            payment_schedule_item_id: String(rowKey(record)),
          },
        ])
      }
    },
    onSelectAll: (selected, selectedRows, changeRows) => {
      if (allSelectedRowKeys.length == TableData.length) {
        // ALL is selected,so deselect
        let selectedRowKeys = changeRows.map((itm) => rowKey(itm))
        const updatedDeselected = selectedRowKeys.map((sel, index) => {
          return {
            payment_schedule_item_id: String(sel),
          }
        })
        let allSelectedIds = String(selectedRowKeys.join("/"))

        submitDeselection(updatedDeselected)
      } else {
        // All is not selected,so select
        let selectedRowKeys = selectedRows.map((itm) => rowKey(itm))
        const updatedSelected = selectedRowKeys.map((sel, index) => {
          return {
            payment_schedule_item_id: String(sel),
          }
        })
        let allSelectedIds = String(selectedRowKeys.join("/"))
        submitSelection(updatedSelected)
      }
    },
    onChange: (
      selectedRowKeys: React.Key[],
      selectedRows: IPayScheduleItemDocsEntity[]
    ) => {
      const UpdatedSumRow = selectedRows.filter(
        (itm) => itm.payment_schedule_item_status !== "Succeeded"
      )

      const sumSelected = UpdatedSumRow.reduce(function (acc, obj) {
        return acc + obj.amount_unedited
      }, 0)
      setAllSelectedRowSum(sumSelected)
    },

    getCheckboxProps: (record) => {
      const typeId = Number(record?.payment_schedule_item_type_id)
      return {
        disabled:
          Number(record?.payment_schedule_item_status_id) < 3 ||
          record.is_active === false ||
          typeId === 8 ||
          typeId === 11 ||
          typeId === 12 ||
          typeId === 13
            ? true
            : false,
        name: record.full_name ?? "",
      }
    },
  }
  useEffect(() => {
    let updatedSelectedKeys = TableData.filter((item) => {
      return (
        item.is_selected || Number(item.payment_schedule_item_type_id) === 8
      )
    })
    if (updatedSelectedKeys.length) {
      setAllSelectedRowsKeys(updatedSelectedKeys.map((ite) => rowKey(ite)))

      const UpdatedSumRow = updatedSelectedKeys.filter(
        (itm) => itm.payment_schedule_item_status !== "Succeeded"
      )

      const sumSelected = UpdatedSumRow.reduce(function (acc, obj) {
        return acc + obj.amount_unedited
      }, 0)
      setAllSelectedRowSum(sumSelected)
    } else {
      setAllSelectedRowsKeys([])
    }
  }, [TableData, rowKey])
  return (
    <>
      <AppTable<IPayScheduleItemDocsEntity>
        rowKey={rowKey}
        rowSelection={{
          type: "checkbox",
          selectedRowKeys: allSelectedRowKeys,
          ...rowSelection,
        }}
        rowClassName={(record) => (!record.enabled ? "disabled-row" : "")}
        columns={TableColumns}
        dataSource={TableData}
        loading={{ spinning: isPaymentLoading, indicator: antIcon }}
        className="text-[#42526D]"
        pagination={{
          pageSize: payoutData?.data?.limit,
          current: payoutData?.data?.page,
          total: payoutData?.data?.totalDocs,
          showSizeChanger: true,
          showTotal: (total, range) => (
            <span className="font-avenir text-padeSubtext grow">
              {range?.[0]}-{range?.[1]} of {total}
            </span>
          ),
          pageSizeOptions: [20, 40, 100, 500, 1000],
        }}
        onChange={(pagination, filters, sorter, extra) => {
          setPagination({
            page: pagination.current!,
            limit: pagination.pageSize!,
          })
          setFilteredData(extra.currentDataSource)
        }}
        scroll={{
          y: "calc(100vh - 300px)",
          x: "max-content",
        }}
        tableLayout="auto"
      />
    </>
  )
}
